import { useContext } from 'react'

import { ConnectedUserContext, OrganizationContext } from 'components'

const useUserHasLicense = () => {
  const connectedUser = useContext(ConnectedUserContext)
  const pbx = useContext(OrganizationContext)

  return (productName: string): boolean =>
    !!(
      connectedUser &&
      pbx?.licensesDetails?.results?.some(
        (license) => license.products?.includes(productName) && license.userKeys?.includes(connectedUser?.key),
      )
    )
}

export default useUserHasLicense
